import { createAction, props } from '@ngrx/store';
import { EventLogsRequest, EventLogsResponse } from '../../../models/event-logs.interface';

export const saveEventLogsData = createAction('[Data] Post Data', props<{ payload: EventLogsRequest }>());
export const saveEventLogsSuccess = createAction('[Data] Post Data Success', props<{ response: EventLogsResponse }>());
